export default () => ({
    token: false,
    refresh_token: false,
    urlBack: '',
    clientName: '',
    config: {
        headers: {
          'Authorization': ''
        }
    }
});